import React, { Fragment } from 'react';

// import ListUser from "../../components/user/List";

const List = () => (
    <Fragment>
        <div className="content-header">
            <h1>Welcome to Admin Dashboard</h1>
        </div>
        {/* <ListUser /> */}
    </Fragment>
)

export default List;